import { Box, Flex, Text, Link, Tag, Wrap, WrapItem, Center, Avatar, VStack } from "@chakra-ui/react";

interface TeamMemberProps {
  name: string,
  role: string[],
  image: string
}

const TeamMember: React.FC<TeamMemberProps> = (props) => {
  const { name, role, image } = props;

  return (
    <>
      <Flex
        w="full"
        alignItems="center"
        justifyContent="center"
      >
        <Box
          position={'relative'}
          mx="auto"
        >
          <Avatar boxSize={64} src={image} />

          <Box
            position={'absolute'}
            top={2}
            left={0}
            right={0}
          >
            <Center>
              <Text
                px={1}
                rounded='lg'
                backgroundColor='white'
                textAlign="center"
                fontWeight="medium"
                fontSize={14}
                textTransform="uppercase"
                color='black'
              >
                {name}
              </Text>
            </Center>
          </Box>

          <Box
            position={'absolute'}
            bottom={-4}
            left={0}
            right={0}
          >
            <Center>
              <VStack justify='center' spacing={-1}>
                {role.map((role, i) => (
                  <Tag variant='subtle' backgroundColor={'black'} fontSize={12}>{role}</Tag>
                ))}
              </VStack>
            </Center>
          </Box>

          {/* <Box
            w={{
              base: 60,
              md: 60,
            }}
            bg="white"
            _dark={{
              bg: "gray.800",
            }}
            mt={-10}
            shadow="lg"
            rounded="lg"
            overflow="hidden"
          >
            <Text
              py={2}
              textAlign="center"
              fontWeight="bold"
              textTransform="uppercase"
              color="gray.800"
              _dark={{
                color: "white",
              }}
              letterSpacing={1}
            >
              {name}
            </Text>

            <Box
              py={2}
              px={3}
              bg="gray.200"
              _dark={{
                bg: "gray.700",
              }}
            >
              <Center>
                <Wrap spacing='30px' spacingX={2} spacingY={2} justify='center'>
                  {role.map((role, i) => (
                    <WrapItem key={i}>
                      <Tag variant='subtle' colorScheme={'orange'}>{role}</Tag>
                    </WrapItem>
                  ))}
                </Wrap>
              </Center>
            </Box>
          </Box> */}
        </Box>
      </Flex>
    </>
  );
};

export default TeamMember;
